
import { COLOR } from "../themes"
import { NOTIFICATION_PARENT_TYPE } from "./constants"

export const backgroundToast = notificationType => {
  switch (notificationType) {
    case NOTIFICATION_PARENT_TYPE.BOOKINGS:
      return COLOR.TOAST_EXTEND
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_INVITE:
      return COLOR.TOAST_EXTEND
    case NOTIFICATION_PARENT_TYPE.ORDERS:
      return COLOR.TOAST_EXTEND
    case NOTIFICATION_PARENT_TYPE.ISSUES:
      return COLOR.TOAST_EXTEND
    case NOTIFICATION_PARENT_TYPE.ORDERS_STATUS_UPDATE:
      return COLOR.TOAST_INVITED
    case NOTIFICATION_PARENT_TYPE.ISSUES_STATUS_UPDATE:
      return COLOR.TOAST_INVITED
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_NEAR_END:
      return COLOR.TOAST_DECLINED
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_UPDATE:
      return COLOR.TOAST_EXTEND
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_DELETE:
      return COLOR.TOAST_DECLINED

    default:
      return COLOR.GOLD_1
  }
}

export const iconToast = notificationType => {
  switch (notificationType) {
    case NOTIFICATION_PARENT_TYPE.BOOKINGS:
      return 'time-white.svg'
    case NOTIFICATION_PARENT_TYPE.ORDERS:
      return 'check-circle.svg'
    case NOTIFICATION_PARENT_TYPE.ISSUES:
      return 'check-circle.svg'
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_INVITE:
      return 'info-white.svg'
    case NOTIFICATION_PARENT_TYPE.ORDERS_STATUS_UPDATE:
      return 'info-white.svg'
    case NOTIFICATION_PARENT_TYPE.ISSUES_STATUS_UPDATE:
      return 'info-white.svg'
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_NEAR_END:
      return 'time-white.svg'
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_UPDATE:
      return 'info-white.svg'
    case NOTIFICATION_PARENT_TYPE.BOOKINGS_DELETE:
      return 'info-white.svg'

    default:
      return ''
  }
}
